import React, { useEffect, useState } from "react";

function Footer() {
  const [appVer, setAppVer] = useState(" ");

  let appVersionData;

  const getAppVer = () => {
    appVersionData = fetch("/app_version.json")
      .then((res) => res.json())
      .then((json) => json && json.name && setAppVer(json.name))
      .catch((err) => setAppVer(" "));
  };

  useEffect(() => {
    getAppVer();
  }, []);

  return (
    <footer className="mt-5">
      <div className="bg-overlay-footer">
        <span className="email-info info-footer">
          <i className="fa-solid fa-phone icon-footer"></i>
          <span>021-91306173</span>
        </span>
        <span className="phone-info info-footer">
          <i className="fa-solid fa-envelope icon-footer"></i>
          <span>support [@] isoogh.ir</span>
        </span>
        <span className="address-info info-footer d-flex">
          <span>شهرک اکباتان خیابان نفیسی مرکز نوآوری‌های آموزشی اکباتان.</span>
          <i className="fa-solid fa-location-dot icon-location mr-1"></i>
        </span>
        <div className="rights-container row text-center">
          <span className="rights">
            کلیه ی حقوق مادی و معنوی این سایت متعلق به بازار هوشمند می باشد.
          </span>
          <span className="ver">{appVer}</span>
        </div>
      </div>
      <div className="wavy-navbar-bottom"></div>
    </footer>
  );
}

export default Footer;
